var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('b-notification',{attrs:{"type":_vm.notificationType,"has-icon":"","aria-close-label":"Close notification","position":"is-top"}},[_vm._v("\n\t"+_vm._s(_vm.notificationContent)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }